module.exports = __webpack_public_path__ + "img/postcard.7159cee6.jpg";